import { get } from "lodash";
import DefinitionValue from "./definitionValue";
import Site from "./site";
import Size from "./size";

export default class AdUnit {
  id?: string;
  ref?: string;
  name: string;
  value: string;
  price: number;
  sites?: Site[];
  siteIds: string[];
  sizes?: Size[];
  sizeIds: string[];
  definitionValues?: DefinitionValue[];
  definitionValueIds: string[];

  constructor(params?: AdUnit) {
    this.id = get(params, "id");
    this.ref = get(params, "ref");
    this.name = get(params, "name", "");
    this.value = get(params, "value", "");
    this.price = get(params, "price", 0);

    const sites = get(params, "sites", []) as Site[];
    const siteIds: string[] = sites.map((i: Site) => i.id as string);
    this.siteIds = get(params, "siteIds", siteIds);

    const sizes = get(params, "sizes", []) as Size[];
    const sizeIds = sizes.map((i: Size) => i.id as string);
    this.sizeIds = get(params, "sizeIds", sizeIds);

    const definitions = get(
      params,
      "definitionValues",
      []
    ) as DefinitionValue[];
    const valueIds = definitions.map((i: DefinitionValue) => i.id as string);
    this.definitionValueIds = get(params, "definitionValueIds", valueIds);
  }
}

export interface AdUnitFilter {
  filter?: any;
  fields?: any;
  site_ids?: string;
  page?: any;
}
